import { localize } from "@gtmhub/localization";

export function status() {
  return function (text: string) {
    if (text === "inprogress") {
      return localize("in_progress");
    }

    if (text === "done") {
      return localize("done");
    }

    if (text === "todo") {
      return localize("to_do");
    }

    if (text === "completed" || text === "scheduled") {
      return localize(text);
    }

    return text;
  };
}
